import React, { Component } from 'react'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';
import Img01 from '../assets/images/news-20160403-img01.png';

const lang = '';

class News20160403001 extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '新聞中心',
      'sc': '新闻中心',
      'en': 'News Center'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  render(){
    return(
      News20160403001JSX(this)
    );
  }
}

const News20160403001JSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className='main-content-container'>
      <div className='main-content-inner-wrapper newsdt'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '新聞',
                    'sc': '新闻',
                    'en': 'News'
                })
              }
            </span>
          </Grid>
        </Grid>
        <div style={{clear:'both'}}></div>

        <div className='newsdt-container'>
          <Grid container spacing={0} className='newsct' id='grid-section' justify='center'>
            <Grid item xs={12} sm={8} md={10} className='news-title theme-color'>
              <span>
                {
                  ctx.getLangText({
                      'tc': `鑫匯寶貴金屬獲“2015十佳黃金交易平台”殊榮`,
                      'sc': `鑫汇宝贵金属获“2015十佳黄金交易平台”殊荣`,
                      'en': `Xinhuibao Precious Metals won the "2015 Top Ten Gold Trading Platform"`
                  })
                }
              </span>
            </Grid>
            <Grid item xs={12} sm={4} md={2} className='news-date'>
              <span>2016.04.03</span>
            </Grid>
          </Grid>

          <Grid item style={{width:'100%', marginBottom:'30px'}}><hr/></Grid>

          <Grid container spacing={0} className='content-container'>
            <Grid item>
              <p>
                {
                  ctx.getLangText({
                    'tc': `近日，由中金在線、黃金網、外匯網聯合主辦的"2015年度財經排行榜、財經博客排行榜頒獎盛典"在福州成功舉辦。本年度財經排行榜評選設立了上市公司、證券、黃金、外匯、期貨、新三板、汽車等十二個獎區，涵蓋五十多個獎項。其中，匯寶資本集團旗下鑫匯寶貴金屬有限公司 (`,
                    'sc': `近日，由中金在线、黄金网、外汇网联合主办的"2015年度财经排行榜、财经博客排行榜颁奖盛典"在福州成功举办。本年度财经排行榜评选设立了上市公司、证券、黄金、外汇、期货、新三板、汽车等十二个奖区，涵盖五十多个奖项。其中，汇宝资本集团旗下鑫汇宝贵金属有限公司 (`,
                    'en': `“2015 Annual Rankings and Financial Blogger Ranking Awards Ceremony” jointly sponsored by China Financial Online (CNFOL), Gold  Network and Foreign Exchange Network was successfully held in Fuzhou. This year's rankings were selected to set up 12 award zones including listed companies, Securities,  Precious Metals, Foreign Exchange, Futures, National Equities Exchange and Quotations(NEEQ), and automobiles, covering more than 50 awards. Among them, Xinhuibao Precious Metals  Co., Ltd. (`
                  })
                }
                {
                  (ctx.lang == "") ? <a href="http://www.91pme.com/tc" style={{textDecoration: 'none'}}>http://www.91pme.com/tc</a> : <a href="http://www.91pme.com" style={{textDecoration: 'none'}}>http://www.91pme.com</a>
                }
                {
                  ctx.getLangText({
                    'tc': `) 受邀出席並領取了"十佳黃金交易平台"獎項。`,
                    'sc': `) 受邀出席并领取了"十佳黄金交易平台"奖项。`,
                    'en': `) a subsidiary of Huibao Capital Group, was invited to attend and received the "Top Ten Gold Trading Platform" award.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                    'tc': `據悉，中金在線年度財經排行榜評選活動已連續舉辦七屆，在業界享有極高的知名度和認可度，每年的評選活動都會引起業界和媒體的廣泛報導。活動旨在通過評選財經及相關領域的優秀企業、機構及個人，為行業樹立標桿，促進行業的服務水平、產品創新。評選過程非常嚴格、客觀、公正。`,
                    'sc': `据悉，中金在线年度财经排行榜评选活动已连续举办七届，在业界享有极高的知名度和认可度，每年的评选活动都会引起业界和媒体的广泛报导。活动旨在通过评选财经及相关领域的优秀企业、机构及个人，为行业树立标杆，促进行业的服务水平、产品创新。评选过程非常严格、客观、公正。`,
                    'en': `China Gold Online Annual Rankings has been held for seven years and enjoys a high reputation and recognition in the industry. The annual selection activities will be widely reported by the industry and the media. The activity aims to set a benchmark for the industry by selecting outstanding companies, institutions and individuals in the materials and related fields to promote service levels and product innovation in the industry. The selection process is very strict, objective and fair.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                    'tc': `本次匯寶資本集團旗下鑫匯寶貴金屬有限公司獲此殊榮，是鑫匯寶優良交易平台和服務水準的有力證明。作為香港金銀業貿易場106號AA類（最高類）行員，鑫匯寶貴金屬主要經營貴金屬現貨投資等金融業務。嚴格遵守貿易場的規範並接受貿易場的監管。力爭打造現貨投資的服務典範，在保證客戶資金安全的前提下，公司不斷提升客戶交易體驗、提高專業品質、樹立優秀服務品牌，務求為客護帶來更完美的投資感受。`,
                    'sc': `本次汇宝资本集团旗下鑫汇宝贵金属有限公司获此殊荣，是鑫汇宝优良交易平台和服务水准的有力证明。作为香港金银业贸易场106号AA类（最高类）行员，鑫汇宝贵金属主要经营贵金属现货投资等金融业务。严格遵守贸易场的规范并接受贸易场的监管。力争打造现货投资的服务典范，在保证客户资金安全的前提下，公司不断提升客户交易体验、提高专业品质、树立优秀服务品牌，务求为客护带来更完美的投资感受。`,
                    'en': `Xinhuibao Precious Metals Co., Ltd., a subsidiary of Huibao Capital Group received this honour, which is a strong proof of our excellent trading platform and customer service. Xinhuibao Precious Metals Co., Ltd. is a member of The Chinese Gold & Silver Exchange Society (member No. 106) and holds AA types of market trading license. precious metal investment is the main business we strict compliance with industry norms and to be An archetype of the  industry. Ensuring the safety of client funds, we will keep improve the customer transaction experience, improve professional quality, and establish an excellent service brand, in order to bring a more perfect investment experience to customers.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                    'tc': `鑫匯寶貴金屬致力於依托優質、專業的互聯網平台，高水平的交易策略和研發水平，快捷安全的資金管理系統、內容豐富的學習資料、全天候的精英團隊咨詢服務等，讓其成為投資者進行貴金屬交易的首選交易平台。也將憑借優良的品牌口碑使鑫匯寶貴金屬在競爭激烈的市場中穩健前行。`,
                    'sc': `鑫汇宝贵金属致力于依托优质、专业的互联网平台，高水平的交易策略和研发水平，快捷安全的资金管理系统、内容丰富的学习资料、全天候的精英团队咨询服务等，让其成为投资者进行贵金属交易的首选交易平台。也将凭借优良的品牌口碑使鑫汇宝贵金属在竞争激烈的市场中稳健前行。`,
                    'en': `Xinhuibao Precious Metals are committed on high-quality, professional online platform, top trading strategy, research and development level, convenient and safe fund management system, rich learning materials, and customer services, be the first choice of investors. Excellent brand reputation to make Xinhuibao Precious Metals move steadily in the highly competitive market.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                    'tc': `走過2015，展望2016，在未來的發展中，鑫匯寶貴金屬願再接再厲，與廣大投資者共同攜手，以創新的思維、高水平的交易策略和研發水平把握國際經濟形勢、共享行業發展盛宴。`,
                    'sc': `走过2015，展望2016，在未来的发展中，鑫汇宝贵金属愿再接再厉，与广大投资者共同携手，以创新的思维、高水平的交易策略和研发水平把握国际经济形势、共享行业发展盛宴。`,
                    'en': `After 2015, looking forward to 2016, in the future, grasp the international economic situation with innovative thinking, advanced trading strategies, research and development. Xinhuibao Precious Metals are willing to take challenge,  win together with investors.`
                  })
                }
              </p>
            </Grid>
            <Grid container spacing={0} justify='center'>
              <Grid item style={{maxWidth:'400px'}}>
                <img src={Img01} style={{ display:'inline-block', verticalAlign:'middle', width:'100%', height:'100%' }} />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  </div>
)

export default News20160403001



// WEBPACK FOOTER //
// ./src/components/pages/PC20160403001.js